import { FormattedMessage } from 'react-intl';
import './CalcResult.scss';

export interface CalcResultProps {
  userCost: string;
  totalRUs: number;
}

const CalcResult = ({ userCost, totalRUs }: CalcResultProps) => {
  return (
    <div className="calc-result">
      <h3 className="calc-result__title">
        <FormattedMessage defaultMessage="Results" id="yaMHMB" />
      </h3>
      <p className="calc-result__user-cost-desc">
        <FormattedMessage
          defaultMessage="We estimate the cost per user per month to be:"
          id="5nfGxu"
        />
      </p>
      <div className="calc-result__user-cost">${userCost}</div>
      <p className="calc-result__resource-units-desc">
        <FormattedMessage
          defaultMessage="According to your entries above, we estimate you will need the following number of resource units for the entirety of the year (12 months):"
          id="C54jTB"
        />
      </p>
      <div className="calc-result__resource-units">{totalRUs}</div>
      <p className="calc-result__move-forward">
        <FormattedMessage defaultMessage="Ready to move forward?" id="hjHa0A" />
      </p>
      <div className="calc-result__actions">
        <a
          className="bx--btn bx--btn--primary calc-result__action"
          href="https://www.ibm.com/account/reg/signup?formid=MAIL-ibm"
        >
          <FormattedMessage defaultMessage="Contact sales" id="W0Tn8Y" />
        </a>
        <a
          className="bx--btn bx--btn--tertiary calc-result__action"
          href="https://www.ibm.com/account/reg/signup?formid=urx-30041"
        >
          <FormattedMessage defaultMessage="Try free edition" id="OHvOSg" />
        </a>
      </div>
    </div>
  );
};

export default CalcResult;
